import { useEffect, type ReactNode } from 'react';
import { MixpanelAnalyticsService } from './MixpanelAnalyticsService';
import { AnalyticsContext } from './AnalyticsContext';

interface AnalyticsProviderProps {
  children: ReactNode;
}

const analyticsService = new MixpanelAnalyticsService();
const SESSION_KEY = 'augur_session_tracked';

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  useEffect(() => {
    // Solo trackear App_Open una vez por sesión de navegador
    if (!sessionStorage.getItem(SESSION_KEY)) {
      const entryPage = window.location.pathname;
      analyticsService.track('App_Open', {
         
        entry_page: entryPage,
        referrer: document.referrer || 'direct',
      });
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
  }, []);

  return (
    <AnalyticsContext.Provider value={analyticsService}>
      {children}
    </AnalyticsContext.Provider>
  );
};
